import { render } from "./Titlebar.vue?vue&type=template&id=509413ad&scoped=true&ts=true"
import script from "./Titlebar.vue?vue&type=script&lang=ts"
export * from "./Titlebar.vue?vue&type=script&lang=ts"

import "./Titlebar.vue?vue&type=style&index=0&id=509413ad&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509413ad"]])

export default __exports__